exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0dc3335d]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px}.app-container .roles-table[data-v-0dc3335d]{margin-top:30px}.app-container .permission-tree[data-v-0dc3335d]{margin-bottom:30px}.app-container .form-item[data-v-0dc3335d]{margin-top:10px;width:140px}.app-container .form-full[data-v-0dc3335d]{width:100%}\n", ""]);

// exports
